import { RunParameter } from "../../../../../api";
import { Parameters } from "../../Parameters";
import { IParameterRenderer, IParamView, ParameterOwnerModel, RenderParamLabSettingsProps } from "../../ParameterRendererAbstracts";
import { BrutusCaseRunCreateModel, CaseRunCalculateModel, CaseRunClient, CaseRunCreateModelBase } from "@app/api2/api";
import { ICreateRenderer } from "../../CaseRunCreate";
import React from "react";
// import "react-datepicker/dist/react-datepicker.css";
import { InformationBrutus2, InformationBrutusValuesState } from "./InformationBrutus";
import { BrutusFeatureSelectSelect } from "./BrutusFeatureSelect";
import { RareAllelesFreqSelect } from "@app/components/React/Common/RareAllelesFreqSelect";
import { BrutusReview } from "./BrutusReview";
import { MarkerSpecificSettingsEditor } from "../../MarkerSpecificSettingsEditor";
import { BrutusResults } from "../../Details/Results/Brutus/BrutusResults";
import { BrutusCaseRuns } from "../../Details/Results/Brutus/BrutusCaseRuns";


export class BrutusHandler implements IParameterRenderer, ICreateRenderer<BrutusCaseRunCreateModel, InformationBrutusValuesState> {
    caseRunClient = new CaseRunClient();

    save(props: { labId: number, caseId: number, model: BrutusCaseRunCreateModel }) {
        return new CaseRunClient().createBrutus(props.labId, props.caseId, props.model)
    }

    async createBlankModel(props: { labId: number, caseId: number, runType: string, evidenceId?: number, ednaTestId?: number }): Promise<BrutusCaseRunCreateModel> {
        return await this.caseRunClient.new(props.labId, props.caseId, props.runType, props.evidenceId, props.ednaTestId ?? null) as BrutusCaseRunCreateModel
    }
    renderReview(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any) {
        return <BrutusReview parameterRenderer={this} model={model as BrutusCaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    renderInformation(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any, rangeOfContributors: boolean) {
        return <InformationBrutus2 model={model as BrutusCaseRunCreateModel} onComplete={onComplete} router={router} />
    }

    runType: string = "brutus";

    canHandle(runType: string): boolean {
        return runType == this.runType;
    }

    applyInformationValuesToModel = (model: BrutusCaseRunCreateModel, values: InformationBrutusValuesState) => {
        model.references = values.references
        model.relations = values.relations
        model.populationId = values.populationId
        model.description = values.description
        model.h1 = values.h1
        model.h2 = values.h2
        model.brutusTestType = values.brutusTestType
        return model
    }

    propsComplete = (model: CaseRunCreateModelBase): void => {
        model.parameters = model.parameters.sort((a, b) => a.order < b.order ? -1 : 1)
    };


    renderParameterEditor(model: CaseRunCreateModelBase | CaseRunCalculateModel, p: RunParameter, values, onChange, errors, setFieldValue): JSX.Element {
        if (p.parameter == "brutusFeatureToUse") {
            return (
                <BrutusFeatureSelectSelect name={p.parameter} value={values[p.parameter]} onChange={(ev, val) => { onChange(p, val) }} />
            );
        } else if (p.parameter == "rareAlleleFreqType") {
            return (
                <RareAllelesFreqSelect name={p.parameter} value={values[p.parameter]} onChange={(ev, val) => { onChange(p, val) }} />
            )
        } else if (p.parameter == "brutusMaleMus") {
            return (
                <MarkerSpecificSettingsEditor
                    readOnly={false}
                    onChange={e => {
                        onChange(p, e)
                    }}
                    onMarkerValueChange={async (marker, value) => { }}
                    // onMarkersValueChange={async (markers, value) => { await this.calcDeltaForDye(model.labId, value, parameters, markers); }}
                    caseId={model.efmCaseId}
                    labId={model.labId}
                    name={p.parameter}
                    value={values[p.parameter]}
                    defaultValue={values.brutusMaleMu} />
            )
        } else if (p.parameter == "brutusFemaleMus") {
            return (
                <MarkerSpecificSettingsEditor
                    readOnly={false}
                    onChange={e => {
                        onChange(p, e)
                    }}
                    onMarkerValueChange={async (marker, value) => { }}
                    // onMarkersValueChange={async (markers, value) => { await this.calcDeltaForDye(model.labId, value, parameters, markers); }}
                    caseId={model.efmCaseId}
                    labId={model.labId}
                    name={p.parameter}
                    value={values[p.parameter]}
                    defaultValue={values.brutusFemaleMu} />
            )
        }


        else return null
    }

    canRenderParameter(parameterName: string): boolean {
        return ["brutusFeatureToUse", "rareAlleleFreqType", "brutusMaleMus", "brutusFemaleMus"].some(pname => pname == parameterName);
    }

    renderParameterView(props: { model: ParameterOwnerModel, p: IParamView }): JSX.Element {
        let p = props.p;
        if (p.parameter == "brutusFeatureToUse") {
            return (
                <BrutusFeatureSelectSelect readOnly name={p.parameter} value={p.value as any} />
            );
        }
        else if (p.parameter == "rareAlleleFreqType") {
            return <RareAllelesFreqSelect readOnly name={p.parameter} value={p.value as any} />
        }
        else if (p.parameter == "brutusMaleMus") {
            return <MarkerSpecificSettingsEditor
                readOnly={true}
                name={p.parameter}
                value={p.value}
                caseId={props.model.efmCaseId}
                labId={props.model.labId} />
        }
        else if (p.parameter == "brutusFemaleMus") {
            return <MarkerSpecificSettingsEditor
                readOnly={true}
                name={p.parameter}
                value={p.value} 
                caseId={props.model.efmCaseId}
                labId={props.model.labId} />
        }
        else {
            return (
                <span>{p.value}</span>
            );
        }
    }

    renderParameterLabSettings?(p: RenderParamLabSettingsProps): JSX.Element {
        if (p.parameter == "brutusFeatureToUse") {
            return (
                <BrutusFeatureSelectSelect readOnly={p.readOnly} name={p.parameter} value={p.value as any} onChange={(ev, val) => { p.onChange(val as any) }} />
            );
        }
        if (p.parameter == "rareAlleleFreqType") {
            return (
                <RareAllelesFreqSelect readOnly={p.readOnly} name={p.parameter} value={p.value as any} onChange={(ev, a) => { p.onChange(a as any) }} />
            );
        }
        return null;
    }

    renderResults?: (props: { labId: number, caseId: number, caseRunId: number }) => React.ReactElement = (props) => {
        return <BrutusResults caseId={props.caseId} labId={props.labId} caseRunId={props.caseRunId} />
    };

    renderRunList?: (props: { canCreateEvidence?: boolean, labId: number, caseId: number }) => React.ReactElement = (props)=>{
        return <BrutusCaseRuns canCreateEvidence={props.canCreateEvidence} {...props} />
    }

    cloneCaseRun?: (props: { labId: number, caseId: number, copyFrom: number }) => Promise<BrutusCaseRunCreateModel> = (props) => {
        return this.caseRunClient.cloneBrutus(props.labId, props.caseId, props.copyFrom)
    }



}



